import {
  queryOptions,
  useQuery,
} from '@tanstack/react-query';
import type { organization } from '@/types';
import type { ScmProviderId } from '@/types/scm-provider';
import { scmAuthHeaders, scmGet } from './scmClient';

interface organizationRes {
  success: boolean;
  statusCode: number;
  message: string;
  data: {
    count: number;
    value: organization[];
  };
}

export const getOrganizationDetails = (
  provider: ScmProviderId,
  patToken: string,
): Promise<organizationRes> => {
  return scmGet(provider, '/api/scm/organizations', patToken);
};

export const getOrganizationQueryOptions = (
  provider: ScmProviderId,
  patToken: string,
) => {
  return queryOptions({
    queryKey: ['org-list', provider, patToken],
    queryFn: () => getOrganizationDetails(provider, patToken),
    refetchOnWindowFocus: false,
    retry: false,
  });
};

interface queryConfig {
  provider: ScmProviderId;
  queryConfig?: {
    enabled?: boolean;
  };
  requesterToken: {
    patToken: string;
  };
}

export const useOrganizationDetail = ({
  provider,
  queryConfig = {},
  requesterToken,
}: queryConfig) => {
  const res = useQuery({
    ...getOrganizationQueryOptions(provider, requesterToken.patToken),
    ...queryConfig,
  });
  return {
    data: res?.data,
    isFetching: res.isFetching,
    error: res?.error,
    status: res?.status,
  };
};
